import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import TransactionsService from 'donor-elf-web/services/transactions-service';

export default class TransactionsEditRoute extends Route {
  @service declare transactionsService: TransactionsService;

  @action
  deactivate() {
    this.transactionsService.lineItemInfos = [];
  }
}
